import { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { useForm } from 'react-hook-form';
import SMModal from '../../shared/SMModal';
import {
  defaultStatus,
  processRowUpdateForStatusOnly
} from './SupplierDataGridUtils';
import TextFieldComponent from '../../shared/TextFieldComponent';
import { isCommentsEmptyOrSame } from '../../shared/UtilFunctions';
import {
  NON_STRATEGIC,
  SRO_SBM_PROP_NAME,
  SRO_SBM_USER_ID_PROP_NAME,
  STRATEGIC
} from '../../shared/AppConstants';
// Strategic to Non-Strategic move
export default function SupplierStatusPopup({
  handleCancel,
  showModal,
  setShowModal,
  supplier,
  updateSupplierStatus,
  setResetStatus,
  dispatchSupplier,
  dispatchNonStrategicSupplier,
  updatedSupplier,
  setNonStrategicSuppliers,
  nonSupplier,
  setNonSupplier,
  movingToStrategicOrNonStrategic
}) {
  const { getValues, control, formState, clearErrors } = useForm({
    mode: 'all'
  });
  const { isDirty } = formState;
  const [showDirtyModal, setShowDirtyModal] = useState(false);
  const [commentAlertType, setCommentAlertType] = useState('warning');
  const handleDirtyModalCancel = () => setShowDirtyModal(false);
  function isFormDirty() {
    return isDirty;
  }

  function cancelAction(e) {
    if (isFormDirty()) setShowDirtyModal(true);
    else resetToPreviousState();
  }

  function resetToPreviousState() {
    clearErrors();
    if (supplier.status === defaultStatus) setResetStatus(true);
    else processRowUpdateForStatusOnly(supplier, updateSupplierStatus);
    handleCancel();
  }

  const cancelDirtyOKAction = () => {
    setShowDirtyModal(false);
    resetToPreviousState();
  };

  function updateSupplier() {
    const comments = getValues('comments');
    if (isCommentsEmptyOrSame(comments, supplier)) {
      setCommentAlertType('error');
    } else {
      const tempSupplier = {
        supplierNumber: supplier.number,
        supplierName: supplier.name,
        status: updatedSupplier.status,
        comments: comments,
        sdis: supplier.sdis,
        riskRating: supplier.riskRating,
        aeRating: supplier.aeRating,
        activeSupplier: supplier?.activeSupplier,
        forecastSpend: supplier?.r12Forecast,
        invoiceSpend: supplier?.r12Spend,
        forecastSpendPercentage: supplier?.forecastSpendPercentage,
        sroSbmName: supplier[SRO_SBM_PROP_NAME],
        sroSbmUserId: supplier[SRO_SBM_USER_ID_PROP_NAME]
      };
      if (movingToStrategicOrNonStrategic === STRATEGIC) {
        dispatchNonStrategicSupplier({ type: 'del', payload: tempSupplier });
        dispatchSupplier({ type: 'add', payload: tempSupplier });
      } else if (movingToStrategicOrNonStrategic === NON_STRATEGIC) {
        dispatchSupplier({ type: 'del', payload: tempSupplier });
        dispatchNonStrategicSupplier({ type: 'add', payload: tempSupplier });
      }

      const res = [...nonSupplier, ...[tempSupplier]];
      setNonSupplier(res);
      setNonStrategicSuppliers(res);
      setShowModal(false);
    }
  }
  return (
    <>
      <Dialog
        aria-describedby="supplier-status-modal-description"
        aria-labelledby="supplier-status-modal-title"
        fullWidth
        maxWidth="sm"
        onClose={cancelAction}
        open={showModal}
      >
        <DialogTitle id="supplier-status-modal-title">
          <Typography variant="h2" gutterBottom>
            Move to {movingToStrategicOrNonStrategic}
          </Typography>

          <Typography variant="labelMedium" gutterBottom>
            {supplier && supplier.number + ' - ' + supplier.name}
          </Typography>
        </DialogTitle>
        <DialogContent id="supplier-status-modal-description">
          <Box component="form">
            <Alert severity={commentAlertType}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <AlertTitle>Updated Comment Required.</AlertTitle>
                <Typography variant="bodySmall">
                  Status Changed to {movingToStrategicOrNonStrategic}.
                </Typography>
              </Box>
            </Alert>

            <Box sx={{ mt: 2 }}>
              <label>
                <Typography component="span" variant="labelMedium">
                  Comments
                </Typography>
                <Typography
                  component="span"
                  variant="labelMedium"
                  aria-label="required field"
                  sx={{ color: 'error.main', ml: 0.5 }}
                >
                  *
                </Typography>
              </label>
              <Box sx={{ mt: 1 }}>
                <TextFieldComponent
                  maxLength="512"
                  minRows={3}
                  name="comments"
                  control={control}
                  isError={commentAlertType === 'error'}
                  defaultValue={supplier && supplier.comments}
                />
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={cancelAction}>
            Cancel
          </Button>

          <Button variant="primary" onClick={updateSupplier}>
            {'Update Supplier'}
          </Button>
        </DialogActions>
      </Dialog>
      <SMModal
        showModal={showDirtyModal}
        handleCancel={handleDirtyModalCancel}
        handleYes={cancelDirtyOKAction}
        title="Changes Will Be Lost"
        msg_line1="Do you want to save your changes before leaving this screen?"
        msg_line2="If you don't save, your changes will be lost."
        cancelText="Cancel"
        yesText="Continue without Saving"
      />
    </>
  );
}
